<template>
  <div class="replinksicons">
    <div class="replinksicons_content">
      <a
        v-for="link in !item
          ? []
          : [
              {
                pathName: 'StudySolutions',
                icon: 'mdi-school',
                tooltip: $t('tooltips.study_spot'),
              },
              {
                pathName: 'PracticeTrainer',
                icon: 'mdi-google-controller',
                tooltip: $t('tooltips.practice_spot'),
              },
            ]"
        :key="link.pathName"
        :href="
          links_getLink({
            namespace,
            pathName: link.pathName,
            customQuery: {
              board: `${flopGroup === 'swv_turns' ? flopBoard : ''}${item.id}`,
              soltab: 'strategy',
              ...(linkParams || {}),
            },
          })
        "
        target="_blank"
        :class="link.icon"
        class="mdi icon_btn replinksicons_item clr-white csst"
        @click.stop
        @mouseenter="e => fl_positionTooltip(e, { placement: 'bottom' })"
      >
        <div
          class="csst_content text-nowrap"
          style="position: fixed"
          v-html="link.tooltip"
        ></div>
      </a>
    </div>
  </div>
</template>

<script>
import links_mix from '@/mixins/links_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'StudyReportsLinks',
  mixins: [float_mix, links_mix],
  props: {
    namespace: { required: true, type: String },
    item: Object,
    flopGroup: String,
    flopBoard: String,
    linkParams: Object,
  },
}
</script>
<style lang="scss" scoped>
.replinksicons {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-shadow: var(--text-shadow_outlined);
  --2nd-child-margin: 0;
  --item-padding: 0.25rem;
  --flex-direction: row;
  &_content {
    display: flex;
    flex-direction: var(--flex-direction);
  }
  &_item {
    padding: var(--item-padding);
    &:nth-child(2) {
      margin-top: var(--2nd-child-margin);
    }
  }
}
</style>
